import { styled } from '@mui/material/styles';

/**
 * Wrapper component for card images (both SVG icons and external card art URLs).
 * Provides consistent styling with fixed dimensions, rounded corners, and proper image scaling.
 */
export const CardImageWrapper = styled('div')({
  width: '50px',
  height: '32px',
  borderRadius: '4px',
  backgroundColor: '#E0E0E0',
  overflow: 'hidden',
  display: 'inline-block',
  flexShrink: 0,
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
});
